import { render, staticRenderFns } from "./SubsetsSettlementsReport.vue?vue&type=template&id=32971ad8&"
import script from "./SubsetsSettlementsReport.vue?vue&type=script&lang=js&"
export * from "./SubsetsSettlementsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports